<template>
  <check-base-layout :pagetitle="pagetitle">
    <template>
      <div>
        <customer-module :customer-data="checkFrom.customerAccountCreditVo"></customer-module>
      </div>
      <check-module :title="`客户合同`" :is-table="true">
        <info-table
          :table-data="tableData"
          :field-arr="tableField"
          :table-height="`300`"
          :timer-format="['updateDate','signDate']"
          :to-fixed-format="['contractTotal','stockupUnPrice','contractAc','accountsDue']"
        ></info-table>
      </check-module>
      <check-module
        :title="`申请信息`"
      >
        <el-row>
          <el-col :span="8">
            <div class="pb20">申请人：{{checkFrom.createUser}}</div>
          </el-col>
          <el-col :span="8">
            <div class="pb20">申请时间：{{checkFrom.createDate | formatData}}</div>
          </el-col>
          <el-col :span="8">
            <div class="pb20">所属部门：{{checkFrom.orgName}}</div>
          </el-col>
        </el-row>
        <el-row>
          <slot name="beforeRemark"></slot>
          <el-col :span="16">
            <div class="">调整至：{{checkFrom.newValue}}星 （系数{{checkFrom.starPoint * 100}}%）</div>
          </el-col>
        </el-row>
      </check-module>
    </template>
    <template #checkFooter>
      <slot name="footer">
        <check-module :title="`审批信息`">
          <check-info-module :check-data="checkFrom.systemFlowRunAuditOrgVo"></check-info-module>
        </check-module>
      </slot>
    </template>
  </check-base-layout>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import checkApi from '@/api/workbench/check'
import { compartState, payTypeStatus } from '@/meun/date'
export default {
  name: 'starleveladjustCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '星级调整审批'
    }
  },
  data () {
    return {
      tableData: [],
      tableField: [{
        name: 'type',
        label: '合同类型'
      }, {
        name: 'contractCode',
        label: '合同编号'
      }, {
        name: 'cusName',
        label: '客户名称'
      }, {
        name: 'payType',
        label: '付款类型',
        formatter: (val) => {
          return payTypeStatus[val]
        }
      }, {
        name: 'contractTotal',
        label: '合同金额'
      }, {
        name: 'stockupUnPrice',
        label: '实际供货成本'
      }, {
        name: 'contractRate',
        label: '毛利率'
      }, {
        name: 'signState',
        label: '合同状态',
        formatter: (val) => {
          return compartState[val]
        }
      }, {
        name: 'deliverState',
        label: '发货状态'
      }, {
        name: 'contractAc',
        label: '已收账款'
      }, {
        name: 'accountsDue',
        label: '已到期账款'
      }, {
        name: 'invoiceState',
        label: '开票状态'
      }, {
        name: 'count',
        label: '售后记录 '
      }, {
        name: 'staffCnName',
        label: '当前负责人'
      }, {
        name: 'orgName',
        label: '所属部门'
      }, {
        name: 'signDate',
        label: '签订时间 '
      }, {
        name: 'updateDate',
        label: '更新时间'
      }]
    }
  },
  created () {
    this.getStarleveladjustCheckInfo()
  },
  methods: {
    getStarleveladjustCheckInfo () {
      const {
        snaId
      } = this
      checkApi.getStarleveladjustCheckInfo({
        snaId
      }).then(res => {
        if (this.isSuccess(res)) {
          this.checkFrom = res.data.obj
          this.tableData = this.checkFrom.contractBaseTransFlowListVoList || []
          this.$emit('update:data', res.data.obj)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
